import { t } from 'ttag'
import { useMutation } from 'react-query'
import { useState } from 'react'
import isEmail from 'validator/lib/isEmail'

import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { Flex } from '@h2/components/layout/flex'
import { TextInput } from '@h2/components/inputs/text'
import { useForm } from '@h2/common/components/hooks/useForm'
import { api, errors } from '@h2/api'
import { Field } from '@h2/components/inputs/field'
import { Button } from '@h2/components/buttons/button'

const ReferEducator = () => {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const { register, error, isInvalid, handleOnSubmit, dispatch } = useForm({
    name(form) {
      if (!form.name?.trim()) {
        return t`Name is required`
      }
    },
    email(form) {
      if (!form.email?.trim() || !isEmail(form.email?.trim())) {
        return t`Valid Email is required`
      }
    }
  })
  const { mutate, isLoading: isSubmitting } = useMutation(
    body =>
      api.fetch('/user/request/educatorreferral', {
        method: 'POST',
        version: 'v1',
        body: JSON.stringify(body)
      }),
    {
      onSuccess: () => {
        setIsSubmitted(true)
      },
      onError: err => {
        const formErrors = errors.getValidation(err)

        if (formErrors) {
          dispatch({ type: 'validate', payload: formErrors })
        }
      }
    }
  )
  const renderForm = () => {
    if (isSubmitted) {
      return <Text>{t`Referral Submitted Successfully`}</Text>
    }

    return (
      <form onSubmit={handleOnSubmit(form => mutate(form))}>
        <Field
          isRequired
          label={t`Name`}
          desc={error.name}
          status={error.name ? 'error' : 'default'}>
          <TextInput placeholder={t`Who are you referring?`} {...register('name')} />
        </Field>
        <Field
          isRequired
          label={t`Email`}
          desc={error.email}
          status={error.email ? 'error' : 'default'}>
          <TextInput
            placeholder={t`What is their e-mail address?`}
            {...register('email')}
          />
        </Field>
        <div style={{ padding: '15px 0' }}>
          <Button
            type="submit"
            isLoading={isSubmitting}
            isDisabled={isSubmitting || isInvalid}>
            {t`Submit Referral`}
          </Button>
        </div>
      </form>
    )
  }

  return (
    <Flex>
      <div>
        <Heading level="3">{t`Get more users, FREE!`}</Heading>
        <Text>
          {t`If you know someone who could benefit from a free navigator account on the
                    ${dynamicValues.systemName}, use the form opposite to refer them.`}
        </Text>
        <Text>{t`For every successful signup, you'll get 10 extra users added to your quota up to 50.`}</Text>
        {renderForm()}
      </div>
      <div>
        <img
          src="/images/headed2/new/share/Share_img.svg"
          alt={t`Present Box`}
          aria-hidden={true}
        />
      </div>
    </Flex>
  )
}

export { ReferEducator }
